export {}

declare global {
    interface Window { Cookiebot: any; }
}

window.addEventListener("CookiebotOnAccept", ( () => {
            window.Cookiebot.changed && location.reload()
        }
        ));
window.addEventListener("CookiebotOnDecline", ( () => {
            window.Cookiebot.changed && location.reload()
        }
        ));